import React, { useState } from "react";
import type { IconBaseProps, IconType } from "react-icons";
import { FiMenu } from "react-icons/fi";
import MobileMenu from "./MobileMenu";

const Navigation: React.FC = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const renderIcon = (Icon: IconType, props?: IconBaseProps) =>
    React.createElement(Icon as unknown as React.FC<IconBaseProps>, props);

  return (
    <>
      {/* Mobile + tablet bar — hidden on xl+ (sidebar takes over on desktop) */}
      <div className="flex items-center border-t border-white/10 bg-[#111111] px-4 py-2.5 xl:hidden">
        <button
          aria-label="Open menu"
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 bg-white/5 text-slate-300 transition-all hover:border-indigo-500/40 hover:text-indigo-400 active:scale-95"
          onClick={() => setIsMobileOpen(true)}
        >
          {renderIcon(FiMenu, { size: 21 })}
        </button>
      </div>

      <MobileMenu
        isOpen={isMobileOpen}
        onClose={() => setIsMobileOpen(false)}
      />
    </>
  );
};

export default Navigation;
